import DatePicker from "react-datepicker";

export default DatePicker;
